import styled from 'styled-components';
import { ContentIcon } from '../Icons';
import { ICON_CLASS } from '../Icons/tokens';
import { TabsRoot, TabsList } from '../Tabs';
import { theme } from '../theme';
import { tokens } from './tokens';
export const StyledTabsRoot = styled(TabsRoot)`
  height: auto;

  && button {
    background: ${theme.colors.transparent};
  }
`;
export const StyledTabsList = styled(TabsList)`
  flex-direction: ${({ $orientation })=>$orientation === 'horizontal' ? 'row' : 'column'};
  inset: -1px;

  ${({ $orientation })=>$orientation === 'horizontal' && `border-bottom: 1px solid ${tokens.StepList.horizontal.borderBottom};`}
`;
export const NoWrapStackItemBase = styled.div`
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.x2};
`;
export const StepIconContainer = styled.div`
  height: ${tokens.StepIcon.height};
  display: flex;
  align-items: center;
  justify-content: center;

  .${ICON_CLASS} {
    width: ${({ $size })=>tokens.IconSize[$size].fontSize};
    height: ${({ $size })=>tokens.IconSize[$size].fontSize};
    color: ${theme.colors.brand600};
  }
`;
export const StyledContentIcon = styled(ContentIcon)`
  width: ${tokens.StepList.vertical.iconSize};
  height: ${tokens.StepList.vertical.iconSize};
`;
